import moment from 'moment';
import { UserProps } from 'types/user';
import { getRoleName, validArray } from 'utils';

interface EmployeeProps {
  defaultOrganisation: string,
  organisations: []
}

interface OrganisationProps {
  orgDescription: string,
  orgRef: string,
}

interface OrganisationRolesProps {
  orgDescription: string,
  orgRef: string,
  roles: {}[],
}


export function deleteOrganisation(orgRef:string, organisations:OrganisationProps[]) {
  function removeOrganisation(organisation:OrganisationProps) {
    return orgRef !== organisation.orgRef;
  }
  return organisations.filter(removeOrganisation);
}

export function findDefaultOrganisation(employeeObj:EmployeeProps) {
  const { defaultOrganisation } = employeeObj;
  function findOrganisation(organisation: OrganisationProps) {
    const { orgRef } = organisation;
    return orgRef === defaultOrganisation;
  }
  return validArray(employeeObj.organisations) && employeeObj.organisations.find(findOrganisation);
}

export function getAvailableOrganisations(organisationList:OrganisationProps[], currentOrganisations:OrganisationRolesProps[]) {
  function filterOrganisations(organisation:OrganisationProps) {
    function matchOrganisation(organisationToMatch:OrganisationProps) {
      return organisationToMatch.orgRef === organisation.orgRef;
    }
    return !currentOrganisations.some(matchOrganisation);
  }
  return organisationList.filter(filterOrganisations);
}

export function getorgDescription(organisation: { orgDescription: string }) {
  return organisation.orgDescription;
}

export function getOrganisationRoles(organisation:OrganisationRolesProps) {
  const { roles, orgRef } = organisation;
  return {
    orgRef,
    roles: roles ? roles.map(getRoleName) : [],
  }
}

export function isActiveUser(user: UserProps) {
  const { endDate, startDate } = user;
  const today = new Date();
  return (
    moment(startDate).isSameOrBefore(today) && moment(endDate).isSameOrAfter(today)
  ) || (moment(startDate).isSameOrBefore(today) && !endDate);
}


export function setRoles(role: { roleName: string }, roles:{ roleName: string }[]) {
  function checkRole(targetRole:{ roleName: string }) {
    return targetRole.roleName === role.roleName;
  }

  function removeRole(targetRole:{ roleName: string }) {
    return targetRole.roleName !== role.roleName;
  }

  if (roles.some(checkRole)) {
    return roles.filter(removeRole);
  }
  return [...roles, role];
}

export function setOrganisations(role: { orgDescription: string }, roles:{ orgDescription: string }[]) {
  function checkRole(targetRole:{ orgDescription: string }) {
    return targetRole.orgDescription === role.orgDescription;
  }

  function removeRole(targetRole:{ orgDescription: string }) {
    return targetRole.orgDescription !== role.orgDescription;
  }

  if (roles.some(checkRole)) {
    return roles.filter(removeRole);
  }
  return [...roles, role];
}

export function setOrganisation(organisations:{ orgDescription: string }[], orgDescription:string) {
  function matchorgRef(organisation: { orgDescription: string }) {
    return organisation.orgDescription === orgDescription;
  }
  return organisations.filter(matchorgRef)[0];
}

export function setRoleName(role:string) {
  return {
    roleName: role,
  }
}

export function setUserState(user:UserProps) {
  const {
    firstName,
    lastName,
    userId,
    startDate,
    endDate,
    defaultOrganisation,
    organisations,
  } = user;
  
  function trimOrganisations(organisation: { roles: { roleName: string }[] }) {
    const organisationCopy = { ...organisation };
    function trimRoles(role:{ roleName:string }) {
      const { roleName } = role;
      return {
        roleName,
      }
    }
    organisationCopy.roles = organisation.roles.map(trimRoles);
    return organisationCopy;
  }

  const trimmedOrganisations = validArray(organisations) ? organisations.map(trimOrganisations) : [];

  return {
    firstName,
    lastName,
    userId,
    startDate,
    endDate,
    defaultOrganisation,
    organisations: trimmedOrganisations,
  }
}

export function sortByorgRef(organisationA:OrganisationProps, organisationB:OrganisationProps) {
  const { orgRef } = organisationA;
  const { orgRef: orgRefB } = organisationB;
  if (orgRef < orgRefB) return -1;
  if (orgRef > orgRefB) return 1;
  return 0;
}